export default "__VITE_ASSET__0d8a5947__"